<template>
	<div class="newsSecondPage1">
		<div v-if="CourseData.length!=0">
			<div class="newsbox">
				<div class="trainItem" v-for="(item,index) in CourseData" :key="index">
					<div style="cursor: pointer" @click="gocourseDetailFn(item)">
						<div class="name overflowone">{{item.trainCourse}}</div>
						<div class="courseinfobox">
							<div>课程编码：
								<span>{{item.trainCode}}</span>
							</div>
							<div>课程起止时间：
								<span>{{item.startTime}}至{{item.endTime}}</span>
							</div>
							<div class="overflowone">培训地点：
								<span>{{item.trainSite}}</span>
							</div>
							<div class="overflowone">培训费用：
								<span>{{item.pay}}</span>
							</div>
							<div>招报人数：
								<span>{{item.playNumber}}</span>
							</div>
							<div>报名截止：
								<span class="deadlinebox">{{item.deadline}}</span>
							</div>
						</div>
					</div>
					<!-- <div class="coursdeadline" v-if="!token" @click="showlogindialog">
                            报名请先登录
                        </div> -->
					<div v-if="!item.isApply">
						<div v-if="item.joinNumber==item.playNumber" class="registeredbox">
							已满员
						</div>
						<div v-else class="immediatelyBtn" @click="singUpFn(item)">
							立即报名
						</div>
					</div>
					<div v-else>
						<div class="registeredbox" style="cursor: pointer;"  @click="singUpFn(item)" v-if="item.isApply!='报名截止'&&item.isApply!='已结束'">
							{{item.isApply}}
						</div>
						<div class="coursdeadline" v-if="item.isApply=='报名截止'">
							{{item.isApply}}
						</div>
						<div class="coursdeadline" v-if="item.isApply=='已结束'">
							{{item.isApply}}
						</div>
					</div>
				</div>
			</div>
			<div class="pagination-box">
				<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
				    :page-sizes="[6, 12, 15]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<div class="emptyBox" v-else>
			<img src="@/assets/imgs/home/emptyimg.png" />
		</div>
		<CourseSingupModal :isShow.sync="singupVisible" v-if="singupVisible" :currentCourse='currentCourse' @successApplyFn='successApplyFn'
		/>
	</div>
</template>
<script>
import CourseSingupModal from '../../CourseSingupModal.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
	components: {
		CourseSingupModal,
	},
	data() {
		return {
			srcUrl: srcUrl,
			currentPage: 1,
			total: 10,
			pageSize: 6,
			CourseData: [],
			// 判断是否登录
			token: sessionStorage.getItem('token'),
			singupVisible: false,
			currentCourse: null,
		}
	},
	watch: {
		$route: {
			handler: function (val, oldVal) {
				let currentNew = JSON.parse(sessionStorage.getItem('currentNew'))
				if (currentNew) {
					if (currentNew.currentPage) {
						this.currentPage = currentNew.currentPage * 1;
						// this.getNews();
					}
					if (currentNew.site) {
						document.body.scrollTop = currentNew.site
					}
				}
				sessionStorage.removeItem('currentNew')
			},
			deep: true,
			immediate: true,
		},
	},
	created() {
		this.getCourseListFn()
	},
	methods: {
		async getCourseListFn() {
			let params = {
				pageSize: this.pageSize,
				pageCurrent: this.currentPage,
				auditResult: 5,
			};
			let data = await httpService.getCourseList(params);
			if (data.code == 200) {
				this.CourseData = data.result.list
				this.total = data.result.total
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.currentPage = 1;
			this.getCourseListFn();
		},
		handleCurrentChange(val) {
			// this.pageSize = 1;
			this.currentPage = val;
			this.getCourseListFn();
		},
		jumpdetailFn() {
			this.$router.push('/course-detail');
		},
		// 立即报名
		singUpFn(val) {
			if (this.token) {
				// 弹报名框
				this.singupVisible = true
				this.currentCourse = val
			}
			else {
				// 提示登录
				this.$message({
					message: '报名请先登录',
					type: 'warning'
				});
			}
		},
		// 报名成功
		successApplyFn() {
			this.singupVisible = false;
			this.getCourseListFn()
		},
		// 课程详情
		gocourseDetailFn(val) {
			let currentNew = {
				menuurl: '/tarin-secondpage/tarin-course',
				currentPage: this.currentPage,
				site: window.scrollY,
				title: '培训报名'
			}
			sessionStorage.setItem('currentNew', JSON.stringify(currentNew))
			this.$router.push({
				path: "/course-detail",
				query: {
					id: val.trainId,
				},
			});
		},

	},
	filters: {
		timer: (value) => {
			return value.substring(0, 10);
		},
	},
}
</script>
<style lang="less" scoped>
.newsSecondPage1 {
	width: 1200px;
	.newsbox {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		min-height: 330px;
		.trainItem {
			margin: 0 28px 30px 0;
			width: 381px;
			height: 325px;
			box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
			// background: url(../assets/imgs/tarin/bgimg1.png) no-repeat 100%;
			background: url(../../../assets/imgs/train/bgimg1.png) no-repeat 100% 100%;
			padding: 24px 26px 24px 20px;
			box-sizing: border-box;
			&:nth-child(3n) {
				margin-right: 0;
			}
			.name {
				font-size: 22px;
				font-weight: bold;
				line-height: 35px;
				color: #448df7;
				position: relative;
				cursor: pointer;
				margin-bottom: 15px;
			}
			.name::before {
				content: '';
				position: absolute;
				width: 68px;
				height: 0px;
				border: 2px solid #448df7;
				opacity: 1;
				background: #448df7;
				left: 0%;
				// transform: translateX(-50%);
				top: 32px;
			}
			.courseinfobox {
				font-size: 16px;
				line-height: 30px;
				color: #666666;
				margin-bottom: 15px;
			}
			.deadlinebox {
				color: #c0c0c0;
			}
			.immediatelyBtn,
			.coursdeadline,
			.registeredbox {
				width: 118px;
				height: 31px;
				line-height: 31px;
				color: #fff;
				margin: 0 auto;
				text-align: center;
			}
			.immediatelyBtn {
				background: #448df7;
				cursor: pointer;
			}
			.coursdeadline {
				background: #c0c0c0;
				cursor: not-allowed;
			}
			.registeredbox {
				background: #4ab344;
			}
		}
	}
}
</style>


